export function getTracker() {
  if (window.Piwik) {
    return window.Piwik.getTracker();
  }

  return null;
}

export function executeTrackerAction(action, ...args) {
  const tracker = getTracker();
  if (!tracker) {
    console.warn('Tracker not available');
    return;
  }

  tracker[action](...args);
}

export function trackEvent(category, action, name, value) {
  executeTrackerAction('trackEvent', category, action, name, value);
}
